module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter"
    }
  }, [_c('p', {
    staticClass: "h1",
    staticStyle: {
      "color": "#82a339"
    },
    attrs: {
      "id": "d7e1427747"
    }
  }, [_c('b', [_vm._v("PROSCIUTTO-WRAPPED ASPARAGUS")])]), _vm._v(" "), _c('p', {
    staticClass: "ext",
    attrs: {
      "id": "d7e1428247"
    }
  }, [_c('b', [_c('i', [_vm._v("Delicate, succulent asparagus is the perfect foil for salty prosciutto. You can assemble these early in the day and bake them at the very last minute.")])])]), _vm._v(" "), _c('p', {
    staticClass: "h4",
    staticStyle: {
      "color": "#496210"
    },
    attrs: {
      "id": "d7e1429547"
    }
  }, [_c('b', [_vm._v("Prep: 25 minutes       Bake: 10 minutes")])]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1430047"
    }
  }, [_vm._v("24 thick asparagus spears, trimmed and peeled")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1430347"
    }
  }, [_vm._v("12 thin slices prosciutto (5 ounces)")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1430647"
    }
  }, [_vm._v("½ cup freshly grated Parmesan cheese")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e1431547"
    }
  }, [_vm._v("¼ teaspoon coarsely ground black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    staticStyle: {
      "margin-top": "1.5em"
    },
    attrs: {
      "id": "d7e1432747"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("1.")])]), _vm._v(" In 5-quart Dutch oven, heat "), _c('i', [_vm._v("3 quarts water ")]), _vm._v("to boiling over high heat. Add asparagus; cook 3 minutes to blanch. Drain; rinse with cold running water. Pat dry with paper towels.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e1434847"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("2.")])]), _vm._v(" Preheat oven to 450°F. Working in batches, spread out prosciutto on cutting board; cut each slice lengthwise in half and separate slightly. Evenly sprinkle 1 teaspoon Parmesan on each prosciutto strip. Place 1 asparagus spear at end of 1 strip; wrap prosciutto in spiral along length of asparagus (don’t cover asparagus tip). Transfer to jelly-roll pan. Repeat with remaining prosciutto, Parmesan, and asparagus. Sprinkle with pepper. If not serving right away, cover and refrigerate up to 6 hours.")]), _vm._v(" "), _c('p', {
    staticClass: "pub",
    attrs: {
      "id": "d7e1438447"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#c15b49"
    }
  }, [_c('b', [_vm._v("3.")])]), _vm._v(" Bake prosciutto-wrapped asparagus 10 minutes. Transfer to paper towels to drain. Arrange on platter and serve warm. Makes 24 appetizers.")]), _vm._v(" "), _c('p', {
    staticClass: "ntx",
    attrs: {
      "id": "d7e1440247"
    }
  }, [_vm._v("Each appetizer: About 28 calories, 3g protein, 1g carbohydrate, 2g total fat (1g saturated), 6mg cholesterol, 148mg sodium.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0dd9eff6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/West_9781618371621_epub_c40_r1.vue
// module id = 186
// module chunks = 0